import ServiceManager from "../../3x1010/services/ServiceManager.js";
export default class NewsLoader {
  constructor() {
    this.newspage = 0;
  }

  init() {
    $('.js-news-load-more').click(() => {
      this.newspage++;
      ServiceManager.standardCall('/api/app/getnewslist?p=' + this.newspage, null, (rs) => {
        if (rs.StatusCode === 200) {
          for (let news of rs.NewsList) {
            const _news = $(".js-news-entry-template").clone(true);
            _news.removeClass("js-news-entry-template");
            _news.attr('href', '/' + TheApp.Locale + '/news/' + news.PrettyUrl);
            $('.js-news-img', _news).attr('src', news.ImgSmall);
            $('.js-news-titolo', _news).text(news.Titolo);
            $('.js-news-sottotitolo', _news).text(news.Sottotitolo);
            $('.js-allnews').append(_news);
          }
        }
      }, 'GET');
    });

    $('.js-workwithus-load-more').click(() => {
      this.newspage++;
      ServiceManager.standardCall('/api/app/getlavoraconnoilist?p=' + this.newspage, null, (rs) => {
        if (rs.StatusCode === 200) {
          for (let news of rs.NewsList) {
            const _news = $(".js-news-entry-template").clone(true);
            _news.removeClass("js-news-entry-template");
            _news.attr('href', '/' + TheApp.Locale + '/workwithus/' + news.PrettyUrl);
            $('.js-news-img', _news).attr('src', news.ImgSmall);
            $('.js-news-titolo', _news).text(news.Titolo);
            $('.js-news-sottotitolo', _news).text(news.Sottotitolo);
            $('.js-allnews').append(_news);
          }
        }
      }, 'GET');
    });
  }
}